import type { FaireProductEntity } from "../../entity_types/product";

export const p_prd2mrqewu: FaireProductEntity = {
  token: "p_prd2mrqewu",
  type: "product",
  name: "Pastel Mahjong Tile Coaster Set of 8 | Chinoiserie",
  brandToken: "b_d3cpxt2ubz",
  brandName: "Design Carolinas",
  imageUrl:
    "https://cdn.faire.com/fastly/46c255932bed15bd23b42a54a788ac7c09d35b9c1e48aca6a0eea3f09146e5c3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c023cc6bbce7de7c48064dc1d902a87e61c7b5d6c0856a4a6eb6833e1c48f39.png",
    "https://cdn.faire.com/fastly/f7020481c49fd9a3d2003a997183e673c07a97ad5ddc6173611139c7843eea7f.png",
    "https://cdn.faire.com/fastly/550fc2b7060c419c5218dda5bcbe89fd8b622dd5dab2b8ee6f2125a9bd2ed664.png",
    "https://cdn.faire.com/fastly/a0faf93724672aca66c0beb60ed668faceedb6de73e33a2d71f4fb036ac25aa5.jpeg",
    "https://cdn.faire.com/fastly/c24e43616857e79de1ad1726cb99ea2fd234e1657210b3685b824ee94671501c.jpeg",
  ],
  priceDollars: 11,
  description:
    'Inspired by antique chinoiserie motifs and mahjong, this coaster set brings a collected, garden-party feel to any tabletop. Each design features delicate watercolor illustrations—ginger jars, pagodas, florals, and birds—framed in a soft bamboo border for a timeless, layered look.\n\nCrafted from durable pulpboard, these coasters are designed to handle everyday use while adding an elevated, decorative touch to entertaining. Lightweight yet sturdy, they’re perfect for cocktails, coffee tables, mahjong nights, and hostess gifting.\n\nMade of 60pt. Pulpboard - these coasters will last multiple uses!\n\nSold and packaged in sets of  8\n\nEach coaster measures 4" x 4" (10.2cm x 10.2cm) and has rounded corners\n\n\nSet of 8 Retail: boxed, labeled and ready to be sold\n\n- Made in the USA',
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:49.276Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
